// import Severity from './severity'
import React, { FC, useEffect, useMemo, useRef } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { v4 as uuid } from 'uuid'
import { CalculatedExam, Content, Rule } from '../../externals/api/applyRules'
import { toNumeric } from '../../utils/formatter'
import { Container } from './styles'

type AppliedRuleProps = {
  name: string
  code?: string
  content: Content[]
  rules: Rule[]
  calculatedExams?: CalculatedExam[]
  type?: 'applied' | 'appliable'
}

const AppliedRule: FC<AppliedRuleProps> = ({
  code,
  name,
  content,
  rules,
  calculatedExams,
  type = 'applied'
}) => {
  const studiesRef = useRef(null)
  const { current: uid } = useRef(uuid())

  const { t } = useTranslation('components')

  useEffect(() => {
    // const ref = studiesRef.current

    // if (ref) {
    //   const act = function (e) {
    //     e.preventDefault()

    //     if ($(this).attr('href')) {
    // eslint-disable-next-line max-len
    //       window.open(config.API_URL + `/helpers/follow-link?url=${$(this).attr('href')}&accessToken=${getConfig().accessToken}`, '_blank')
    //     }

    //     return false
    //   }

    //   $(ref).on('click', 'a', act)

    //   return () => $(ref).off('click', 'a', act)
    // }
  }, [studiesRef])
  const explanation = useMemo(() => {
    return content.find(({ type }) => type === 'explanation')?.text
  }, [content])

  const indicates = useMemo(() => {
    return content.find(({ type }) => type === 'indicates')?.text
  }, [content])

  const studies = useMemo(() => {
    return content.find(({ type }) => type === 'studies')?.text
  }, [content])

  const isConverted = useMemo(() => {
    return !!rules.find(d => d.exam.isConverted)
  }, [rules])

  return (
    <Container id={`applied-rule-${uid}`}>
      <div className='small-info'>
        {type === 'applied' && t('appliedRules.appliedRule')}
        {type === 'appliable' && t('appliedRules.appliableRules')}
      </div>
      <div className='large-info' title={name + (code ? ` (${code})` : '')}>{name}</div>
      {explanation && (
        <>
          <div className='small-info'>{t('appliedRules.explanation')}</div>
          <div
            className='applied_rule_content'
            dangerouslySetInnerHTML={{ __html: explanation }}
          />
        </>
      )}
      {indicates && (
        <>
          <div className='small-info'>{t('appliedRules.indicates')}</div>
          <div
            className='applied_rule_content'
            dangerouslySetInnerHTML={{ __html: indicates }}
          />
        </>
      )}
      {rules && (
        <>
          <div className='small-info second'>{t('appliedRules.results')}</div>
          <div className='applied_rule_content'>
            <ul className='exam-results'>
              {rules.map((d, i) => (
                <li key={`d-${name}-${i}`}>
                  {d.exam.name} ({toNumeric(d.exam.result)} {d.exam.measurement})
                </li>
              ))}
              {calculatedExams?.map((d, i) => {
                const calculatedValue = d.calculatedValue.toFixed(2).replace('.', ',')
                return (
                  <li key={`d-calculated-${d.values[0]}-${d.values[1]}-${i}`}>
                    <Trans i18nKey='calculatedValue'>
                      Valor calculado ({calculatedValue})
                    </Trans>
                  </li>
                )
              })}
            </ul>
          </div>
        </>
      )}
      {studies && (
        <>
          <div className='small-info second'>{t('appliedRules.studies')}</div>
          <div
            className='studies'
            ref={studiesRef}
            dangerouslySetInnerHTML={{ __html: studies }}
          />
        </>
      )}
      {isConverted && (
        <>
          <hr />
          <small>
            <Trans i18nKey='isConvertedWarning'>
              <b>Atenção:</b>
              Essa regra foi ativada utilizando conversão de unidade de medida.
            </Trans>
          </small>
        </>
      )}
    </Container>
  )
}

export default AppliedRule
